import React from 'react'
import "./NotFound.css"

const NotFound = () => {
  return (
    <div className='notfoundcontainer'>
     <img className="notfound" src='https://media.licdn.com/dms/image/C5112AQEw1fXuabCTyQ/article-inline_image-shrink_1500_2232/0/1581099611064?e=1727913600&v=beta&t=Vp3IyXL7YZAfOlGACjz0jq3_fnu-t-smCoyv4L3eNFY'/>
    </div>
  )
}

export default NotFound
